<set-up-form-creation
[data]="data"
(parentFun)="parentFun($event)"
(individualLocationNextStep)="individualLocationNextStep($event)" 
>
    
</set-up-form-creation>
